(function () {
  'use strict';

  function initPurchaseActions(productInfo) {
    if (productInfo.dataset.pdpPurchaseInitialized === 'true') return;

    var form = document.getElementById(productInfo.dataset.productFormId);
    var mainBuyNow = productInfo.querySelector('[data-pdp-main-buy-now]');
    var submit = form && form.querySelector('[type="submit"]');
    if (!form || !mainBuyNow || !submit) return;
    productInfo.dataset.pdpPurchaseInitialized = 'true';

    var productForm = form.closest('product-form');
    var mainBuyNowText = productInfo.querySelector('[data-pdp-main-buy-now-text]');
    var mainBuyNowSpinner = productInfo.querySelector('[data-pdp-main-buy-spinner]');
    var processing = false;
    var submitAriaBeforeCheckout = null;

    function setDisabled(button, disabled) {
      if (!button) return;
      if (button.disabled !== disabled) button.disabled = disabled;
      if (button.getAttribute('aria-disabled') !== String(disabled)) {
        button.setAttribute('aria-disabled', String(disabled));
      }
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function setHidden(node, hidden) {
      if (node && node.hidden !== hidden) node.hidden = hidden;
    }

    function setMainError(message) {
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage(message || false);
      }
      if (!productForm) return;
      var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
      var errorMessage = wrapper && wrapper.querySelector('.product-form__error-message');
      if (wrapper) wrapper.toggleAttribute('hidden', !message);
      if (errorMessage) errorMessage.textContent = message || '';
    }

    function isUnavailableText(text) {
      var normalized = String(text || '').trim().toLowerCase();
      return normalized.indexOf('unavailable') !== -1;
    }

    function checkoutErrorCode(message) {
      var normalized = String(message || '').toLowerCase();
      if (normalized.indexOf('sold out') !== -1 || normalized.indexOf('unavailable') !== -1) return 'sold_out';
      if (normalized.indexOf('variant') !== -1) return 'invalid_variant';
      return 'cart_api_error';
    }

    function sync() {
      var variantInput = form.querySelector('[name="id"]');
      var submitTextNode = submit.querySelector('span');
      var submitText = submitTextNode ? submitTextNode.textContent.trim() : submit.textContent.trim();
      var submitLoading = submit.classList.contains('loading');
      var unavailable =
        submit.disabled ||
        (submit.getAttribute('aria-disabled') === 'true' && !submitLoading && !processing) ||
        !variantInput ||
        variantInput.disabled ||
        !variantInput.value;
      // Checkout uses the existing cart; only wait for an active add-to-cart request.
      setDisabled(mainBuyNow, processing || submitLoading);
      mainBuyNow.classList.toggle('is-loading', processing);
      setHidden(mainBuyNowSpinner, !processing);
      setText(
        mainBuyNowText,
        processing
          ? productInfo.dataset.processingLabel || 'Processing...'
          : productInfo.dataset.checkoutLabel || 'Checkout'
      );

      if (submit.classList.contains('pdp-v2-add-to-cart')) {
        var unavailableLabel = isUnavailableText(submitText)
          ? productInfo.dataset.unavailableLabel || 'Unavailable'
          : productInfo.dataset.soldOutLabel || 'Sold out';
        var mainAddLabel = submitLoading
          ? productInfo.dataset.addingLabel || 'Adding to cart...'
          : unavailable
            ? unavailableLabel
            : productInfo.dataset.addLabel || 'Add to cart';
        if (submit.getAttribute('aria-label') !== mainAddLabel) submit.setAttribute('aria-label', mainAddLabel);
        if (submit.getAttribute('title') !== mainAddLabel) submit.setAttribute('title', mainAddLabel);
      }
    }

    function dispatchDirectCheckout(stage, detail) {
      document.dispatchEvent(
        new CustomEvent('pdp:main-buy-now', {
          detail: Object.assign(
            {
              stage: stage,
              productId: productInfo.dataset.productId || '',
            },
            detail || {}
          ),
        })
      );
    }

    function resetCheckoutState() {
      if (!processing) return;
      processing = false;
      if (submitAriaBeforeCheckout === null) submit.removeAttribute('aria-disabled');
      else submit.setAttribute('aria-disabled', submitAriaBeforeCheckout);
      submitAriaBeforeCheckout = null;
      setMainError('');
      sync();
    }

    function checkout() {
      if (processing || mainBuyNow.disabled || submit.classList.contains('loading')) return;

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput && variantInput.value ? String(variantInput.value) : '';
      var checkoutQuantity = Number(form.querySelector('[name="quantity"]')?.value) || 1;
      var cartAddAttempted = false;
      var checkoutDetail = { variantId: variantId, quantity: checkoutQuantity };

      processing = true;
      submitAriaBeforeCheckout = submit.getAttribute('aria-disabled');
      submit.setAttribute('aria-disabled', 'true');
      setMainError('');
      sync();

      var cartUrl = productInfo.dataset.cartUrl || '/cart';
      var cartAddUrl = productInfo.dataset.cartAddUrl || '/cart/add.js';
      if (cartUrl.charAt(cartUrl.length - 1) === '/') cartUrl = cartUrl.slice(0, -1);

      function knownCartItemCount() {
        var renderedCount = Number(productInfo.dataset.cartItemCount) || 0;
        document.querySelectorAll('.wbhcartitem').forEach(function (node) {
          var count = Number(String(node.textContent || '').replace(/[^0-9]/g, '')) || 0;
          if (count > renderedCount) renderedCount = count;
        });
        return renderedCount;
      }

      fetch(cartUrl + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('We could not read your cart. Please try again.');
          return response.json();
        })
        .catch(function (error) {
          // Theme previews can redirect /cart.js to the shop's canonical domain.
          // Use the server-rendered/cart-bubble count in that case.
          if (knownCartItemCount() >= 0) return { item_count: knownCartItemCount() };
          throw error;
        })
        .then(function (cart) {
          if (Number(cart.item_count) > 0) {
            dispatchDirectCheckout('started', checkoutDetail);
            return;
          }

          if (!variantInput || !variantId || variantInput.disabled) {
            var unavailableError = new Error('This product is currently unavailable.');
            unavailableError.code = 'sold_out';
            throw unavailableError;
          }

          var formData = new FormData(form);
          formData.set('id', variantId);
          cartAddAttempted = true;
          dispatchDirectCheckout('cart_add_attempted', checkoutDetail);
          return fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: formData,
          }).then(function (response) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (payload) {
                if (!response.ok || payload.status) {
                  var errorMessage =
                    payload.description || payload.message || 'We could not add this product. Please try again.';
                  var addError = new Error(errorMessage);
                  addError.code = checkoutErrorCode(errorMessage);
                  throw addError;
                }
                dispatchDirectCheckout('cart_add_succeeded', checkoutDetail);
                dispatchDirectCheckout('started', checkoutDetail);
              });
          });
        })
        .then(function () {
          window.location.assign(productInfo.dataset.checkoutUrl || '/checkout');
        })
        .catch(function (error) {
          if (cartAddAttempted) {
            dispatchDirectCheckout('cart_add_failed', {
              ...checkoutDetail,
              errorCode: error && error.code ? error.code : 'network_error',
            });
          }
          resetCheckoutState();
          var message = error && error.message ? error.message : 'We could not start checkout. Please try again.';
          setMainError(message);
        });
    }

    mainBuyNow.addEventListener('click', checkout);
    form.addEventListener(
      'submit',
      function (event) {
        if (!processing) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );
    // A back/forward-cache restore keeps this closure and the disabled DOM intact.
    window.addEventListener('pageshow', resetCheckoutState);
    new MutationObserver(sync).observe(productInfo, { childList: true, subtree: true, attributes: true });
    sync();
  }

  function styleChatButton() {
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (!root) return false;
    var button = Array.from(root.querySelectorAll('button, [role="button"]')).find(function (element) {
      return /chat/i.test(element.textContent || element.getAttribute('aria-label') || '');
    });
    if (!button) return false;

    button.style.setProperty('background', '#7e5e9b', 'important');
    button.style.setProperty('background-color', '#7e5e9b', 'important');
    button.style.setProperty('border', '0', 'important');
    button.style.setProperty('border-radius', '999px', 'important');
    button.style.setProperty('box-shadow', '0 0.6rem 1.8rem rgba(36, 36, 36, 0.18)', 'important');
    button.style.setProperty('color', '#fff', 'important');
    button.style.setProperty('font-size', '14px', 'important');
    button.style.setProperty('height', '46px', 'important');
    button.style.setProperty('min-width', '100px', 'important');
    button.style.setProperty('padding', '0 18px', 'important');
    var buttonNudge = button.closest('.activator-nudge') || button.parentElement;
    if (buttonNudge) {
      buttonNudge.style.setProperty('bottom', '8rem', 'important');
    }
    button.querySelectorAll('svg, svg path').forEach(function (icon) {
      icon.style.setProperty('color', '#fff', 'important');
      icon.style.setProperty('fill', '#fff', 'important');
      icon.style.setProperty('stroke', '#fff', 'important');
    });

    if (!host.pdpChatObserver) {
      host.pdpChatObserver = new MutationObserver(styleChatButton);
      host.pdpChatObserver.observe(root, { childList: true, subtree: true });
    }
    return true;
  }

  function initChatButton() {
    var attempts = 0;
    window.addEventListener('resize', styleChatButton, { passive: true });
    var timer = window.setInterval(function () {
      attempts += 1;
      if (styleChatButton() || attempts >= 24) window.clearInterval(timer);
    }, 250);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-purchase]').forEach(initPurchaseActions);
    initChatButton();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
